<template>
  <div class="intro-section">
    <div class="intro-left reveal">
      <span class="section-eyebrow">Join The Family</span>
      <h2 class="section-title">Made for<br />bold eyes,<br />bold voices.</h2>
    </div>
    <div class="intro-right">
      <p class="intro-p reveal reveal-delay-1">
        <strong
          >Are you an influencer, content creator, or fashion enthusiast</strong
        >
        with a love for designer eyewear? We'd love to hear from you.
      </p>
      <p class="intro-p reveal reveal-delay-2">
        At Hooligans Eyewear, we believe that the right collaboration is more
        than a post — it's a genuine partnership built on a shared love of
        style, authenticity, and making luxury eyewear accessible. Whether you
        have 1,000 followers or 1,000,000,
        <strong>what matters most is your passion and your voice.</strong>
      </p>
      <p class="intro-p reveal reveal-delay-3">
        We work with creators who truly love what they wear and who want to
        share that with their communities. If that sounds like you, send us a
        message and let's talk.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkWithUsIntro",
};
</script>
